import React from "react";
import NarrativeBase from "../../../../common/NarrativeBase";

export default function Narrative() {
  return <NarrativeBase formKey="info.theftOfGas" />;
}
